import { render, staticRenderFns } from "./dvr.vue?vue&type=template&id=57172588&scoped=true&"
import script from "./dvr.vue?vue&type=script&lang=js&"
export * from "./dvr.vue?vue&type=script&lang=js&"
import style0 from "./dvr.vue?vue&type=style&index=0&id=57172588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57172588",
  null
  
)

export default component.exports